import escapeRegExp from 'src/utils/escapeRegExp'

const script = document.currentScript
const origin = new URL(script.src, location).origin

// Ignore browsers older than Safari 15.4 and leaky bots
if (Array.prototype.at && origin && location.origin) {

Honeybadger.configure({
  apiKey: 'hbp_wWUn8K1HHQsenTR6lKhO6L9A2f7CXj2C0lM4',
  environment: script.dataset.env,
  maxErrors: 10,
})

Honeybadger.beforeNotify(notice => {
  if (Object.keys(notice.context).length) return

  if (!notice.stack.includes(origin) && !notice.stack.includes(location.origin))
    return false

  if (
    (([ origin, pathname, search ]) =>
      new RegExp(`${origin}(:443)?${pathname}(${search})?:1:`)
    )([ 'origin', 'pathname', 'search' ].map(key =>
      escapeRegExp(location[key])
    )).test(notice.stack)
  ) return false

  if (notice.stack.includes('chrome-extension://')) return false
  if (notice.stack.includes('//js.hsforms.net/forms/v2.js')) return false
  if (notice.stack.includes('/assets/fontawesome-')) return false
  // Errors thrown *inside* Google's reCAPTCHA bundle — e.g. a null-promise
  // `.then` when grecaptcha.reset() runs during an unmount that races the
  // widget's own load. Match the top (throw-site) frame, not the whole
  // stack: our frames appear only because react-google-recaptcha calls
  // into Google's code, so a blanket stack match would also swallow real
  // bugs in our onChange/onExpired/onErrored handlers (those throw with
  // OUR bundle on top and gstatic merely lower down).
  if (
    (notice.stack.split('\n').find(line => /https?:\/\//.test(line)) || '')
      .includes('gstatic.com/recaptcha/')
  ) return false
  if (/^[\$A-Za-z]{2}\[[A-Za-z]\]\.push is not a function$/.test(notice.message))
    return false
  if (/^\$\(\.\.\.\)\.[a-z]+ is not a function$/.test(notice.message))
    return false
  if (/\.forEach is not a function$/.test(notice.message)) return false

  // A third-party injected script (a scraper/bot's eval'd instrumentation —
  // <anonymous>, no source map) has monkeypatched appendChild to
  // JSON.stringify the node it inserts. React DOM nodes carry a circular
  // __reactFiber$… back-reference, so it throws during React's commit phase,
  // surfacing our react bundle in the stack though the fault is entirely in
  // the injected wrapper. __reactFiber is React's private key we never touch,
  // and it appears in no other reported error, so this is a precise match
  // (narrower than the generic "circular structure" message our own
  // postMessage stringify could emit).
  if (notice.message.includes('__reactFiber')) return false

  if (/\((script in )?https?:\/\//.test(notice.message)) return false

  if ([
    'ResizeObserver loop completed with undelivered notifications.',
    'ResizeObserver loop limit exceeded',
    'requestAnimationFrame is not defined',
    // DOM APIs absent on headless bots but present in every real browser
    // past our Safari-15.4 init gate — so these only ever come from bots.
    'IntersectionObserver is not defined',
    'ResizeObserver is not defined',
    'Application is not defined',
    'hbspt is not defined',
    'React is not defined',
    'ReactDOM is not defined',
    '$ is not defined',
    'bootstrap is not defined',
    "Can't find variable: hbspt",
    "Can't find variable: React",
    "Can't find variable: bootstrap",
    "Can't find variable: Application",
    "Can't find variable: ResizeObserver",
    "Can't find variable: IntersectionObserver",
    "ReferenceError: Can't find variable: hbspt",
    "ReferenceError: Can't find variable: bootstrap",
    "Cannot read property 'randomUUID' of undefined",
    // A browser extension's content script (obfuscated, loaded as a blob on
    // our origin so it defeats the origin gate above) self-aborting because
    // it ran outside an extension context. Not our code.
    'This script should only be loaded in a browser extension.',
    'UnhandledPromiseRejectionWarning: TypeError: Failed to fetch',
    'UnhandledPromiseRejectionWarning: Error: Failed to load Stripe.js',
    'UnhandledPromiseRejectionWarning: Error: Stripe.js not available',
    "Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript.",
    "Failed to execute 'webkitMatchesSelector' on 'Element': '*[object Object]' is not a valid selector.",
    `Blocked a frame with origin "${location.origin}" from accessing a cross-origin frame.`,
    `UnhandledPromiseRejectionWarning: SecurityError: Blocked a frame with origin "${location.origin}" from accessing a cross-origin frame.`,
  ].includes(notice.message)) return false
})

}
